<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-row :gutter="24">
        <!-- 概览卡片 -->
        <a-col :xs="24" :sm="12" :md="8" :lg="6">
          <a-card class="stat-card">
            <a-statistic
              title="平台库存总金额"
              :value="overview.totalStockAmount"
              :precision="2"
              prefix="¥"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6">
          <a-card class="stat-card clickable" @click="goToStockWarning">
            <a-statistic
              title="库存预警商品数"
              :value="overview.stockWarningCount"
              :value-style="{ color: '#cf1322' }"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6">
          <a-card class="stat-card clickable" @click="goToPurchaseOrder">
            <a-statistic
              title="待审核要货单"
              :value="overview.pendingPurchaseCount"
              :value-style="{ color: '#faad14' }"
            />
          </a-card>
        </a-col>
        <a-col :xs="24" :sm="12" :md="8" :lg="6">
          <a-card class="stat-card clickable" @click="goToReturnOrder">
            <a-statistic
              title="待审核退货单"
              :value="overview.pendingReturnCount"
              :value-style="{ color: '#ba4454' }"
            />
          </a-card>
        </a-col>
      </a-row>

      <!-- 商品要货数量排名 -->
      <a-card title="要货商品数量排名" style="margin-top: 24px" :bordered="false">
        <a-table
          :columns="goodsPurchaseRankColumns"
          :data-source="goodsPurchaseRankList"
          :loading="goodsPurchaseRankLoading"
          :pagination="{
            current: goodsPurchaseRankQuery.pageNo,
            pageSize: goodsPurchaseRankQuery.pageSize,
            total: goodsPurchaseRankTotal,
            showSizeChanger: true,
            showTotal: total => `共 ${total} 条`
          }"
          size="small"
          rowKey="skuId"
          @change="handleGoodsPurchaseRankTableChange"
        >
          <template slot="rank" slot-scope="text, record, index">
            <a-tag v-if="index === 0" color="gold">NO.1</a-tag>
            <a-tag v-else-if="index === 1" color="#C0C0C0">NO.2</a-tag>
            <a-tag v-else-if="index === 2" color="#CD7F32">NO.3</a-tag>
            <span v-else>NO.{{ index + 1 }}</span>
          </template>
          <template slot="purchaseAmount" slot-scope="text">
            <span v-if="text !== null && text !== undefined && text !== ''">
              ¥{{ typeof text === 'number' ? text.toFixed(2) : parseFloat(text).toFixed(2) }}
            </span>
            <span v-else>¥0.00</span>
          </template>
        </a-table>
      </a-card>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  getPlatformRetailOverview,
  getGoodsPurchaseRankStatistics
} from '@/api/retail/statistics'

export default {
  name: 'PlatformStatistics',
  data() {
    return {
      overview: {
        totalStockAmount: 0,
        stockWarningCount: 0,
        pendingPurchaseCount: 0,
        pendingReturnCount: 0,
        pendingTransferCount: 0,
        monthlyPurchaseAmount: 0,
        monthlyReturnAmount: 0
      },
      goodsPurchaseRankList: [],
      goodsPurchaseRankLoading: false,
      goodsPurchaseRankTotal: 0,
      goodsPurchaseRankQuery: {
        pageNo: 1,
        pageSize: 10
      },
      goodsPurchaseRankColumns: [
        { title: '排名', dataIndex: 'rank', width: 80, align: 'center', scopedSlots: { customRender: 'rank' } },
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150, align: 'center' },
        { title: '要货数量', dataIndex: 'purchaseQuantity', width: 100, align: 'center' },
        { title: '要货金额(元)', dataIndex: 'purchaseAmount', width: 120, align: 'center', scopedSlots: { customRender: 'purchaseAmount' } },
        { title: '要货单数', dataIndex: 'purchaseOrderCount', width: 100, align: 'center' },
        { title: '涉及门店数', dataIndex: 'storeCount', width: 100, align: 'center' }
      ]
    }
  },
  mounted() {
    this.loadOverview()
    this.loadGoodsPurchaseRank()
  },
  methods: {
    loadOverview() {
      getPlatformRetailOverview({}).then(response => {
        this.overview = response.data || this.overview
      })
    },
    loadGoodsPurchaseRank() {
      this.goodsPurchaseRankLoading = true
      getGoodsPurchaseRankStatistics({
        pageNo: this.goodsPurchaseRankQuery.pageNo,
        pageSize: this.goodsPurchaseRankQuery.pageSize
      }).then(response => {
        console.log('商品要货排名数据:', response)
        this.goodsPurchaseRankList = response.data?.records || []
        this.goodsPurchaseRankTotal = response.data?.total || 0
      }).finally(() => {
        this.goodsPurchaseRankLoading = false
      })
    },
    handleGoodsPurchaseRankTableChange(pagination) {
      this.goodsPurchaseRankQuery.pageNo = pagination.current
      this.goodsPurchaseRankQuery.pageSize = pagination.pageSize
      this.loadGoodsPurchaseRank()
    },
    goToStockWarning() {
      this.$router.push({ name: 'Inventory' })
    },
    goToPurchaseOrder() {
      this.$router.push({ name: 'Purchase' })
    },
    goToReturnOrder() {
      this.$router.push({ name: 'Return' })
    }
  }
}
</script>

<style scoped>
.stat-card {
  margin-bottom: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-card.clickable {
  cursor: pointer;
  transition: all 0.3s;
}

.stat-card.clickable:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.stat-card >>> .ant-statistic-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

.stat-card >>> .ant-statistic-content {
  font-size: 24px;
  font-weight: 600;
}
</style>
